import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { NavigationService } from "@/utils/navigation";

// Component to initialize the navigation service
export const NavigationInitializer = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    NavigationService.setNavigate(navigate);
    
    // Cleanup when component unmounts
    return () => {
      NavigationService.setNavigate(() => {
        window.location.href = '/';
      });
    };
  }, [navigate]);
  
  return null; // This component doesn't render anything
};